module.exports = __webpack_public_path__ + "img/icon_play_3.59ff57b7.svg";